import React, { useState, useEffect } from 'react';

const WishlistCount = ({ productId, className = '' }) => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (productId) {
      fetchCount();
    }
  }, [productId]);

  const fetchCount = async () => {
    try {
      const res = await fetch(`/api/wishlist/product/${productId}/count`);
      if (res.ok) {
        const data = await res.json();
        setCount(data.count || 0);
      }
    } catch (error) {
      console.error('Error fetching wishlist count:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <span className={`text-gray-400 ${className}`}>...</span>;
  }

  return (
    <span className={`inline-flex items-center gap-1 text-gray-600 ${className}`}>
      <span>⭐</span>
      <span>{count}</span>
      <span className="text-xs text-gray-400">wishlists</span>
    </span>
  );
};

export default WishlistCount;
